import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import { connect } from 'react-redux';
import helper from 'utils/helpers'
import ProfilePicture from 'components/ProfilePicture';
import DniTemplate from '../UserDetail/dniTemplate';
import { get } from 'services';
import Alerts from 'utils/alerts' 

const mt10 = {
    marginTop: 5
}
const sidebarWrapper = {
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center', 
}

const lowercase = {
    textTransform: 'lowercase'
}

const professionSize = {
    fontSize: 17
}

const isBrowserMt = isBrowser ? mt10 : null;

const UserCard = ({user}) => {
    const [dniTypes, setDniTypes] = useState([]);

    const [region, setRegion] = useState('No especificado');
    const [provincia, setProvincia] = useState('No especificado');


    const capitalizeCustom = (data) => {
        if (data) {
            return data.toLowerCase().charAt(0).toUpperCase() + data.toLowerCase().slice(1)
        }
        return "";
    }

    const capitalizeFirstName = (firstName) => {
        if (firstName) {
          let nombre = "";
          const nameSplitted = firstName.toLowerCase().split(" ");
            nameSplitted.forEach(name => {
              nombre += " " + capitalize(name);
          });
          return nombre;
        }
        return "";
    }
    
    const capitalize = (value) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    useEffect(() => {
        (async function mounted() {
            try {
                get('DniTipo').then(response => {
                    setDniTypes(response.data)
                })
                if (user.persona && user.persona.ciudadId) {
                    const ciudad = await get(`Ciudad?$filter=Id eq ${user.persona.ciudadId}`);
                    const prov = await get(`Provincia?$filter=Id eq ${ciudad.data[0].provinciaId}`);
                    const rgn = await get(`Region?$filter=Id eq ${prov.data[0].regionId}`);
                    setProvincia(prov.data[0].nombre)
                    setRegion(rgn.data[0].nombre)
                }
            } catch (error) {
                //Alerts.operationFail()
            } 
        })();
        return function cleanup() {
            setDniTypes([]);
        };
    }, [])

    return (
        <Card>
            <Card.Body >
                <Row style={sidebarWrapper}>
                    <Col md={3}>
                        <ProfilePicture size={300}/>
                    </Col>
                    <Col md={4}>
                        <Row>
                        <Col xs={12}>
                                <h1> 
                                { capitalizeFirstName(user.persona.nombre) } {' '}
                                { capitalizeCustom(user.persona.primerApellido) } {' '}
                                { capitalizeCustom(user.persona.segundoApellido) }
                                </h1>
                                <p style={professionSize}>{ user.persona.profesionUI }  </p>
                            </Col>
                            <Col xs={isBrowser ? 4 : 12}>
                                <strong> Edad </strong>
                            </Col>
                            <Col xs={isBrowser ? 8 : 12}>
                                { 
                                    user.persona.fechaNacimiento 
                                        ? (helper.getYearsFromDate(user.persona.fechaNacimiento) > 2000) ? 'No especificado' : helper.getYearsFromDate(user.persona.fechaNacimiento) + ' años'
                                        : 'No especificado' 
                                }
                            </Col>
                            <Col style={mt10} xs={isBrowser ? 4 : 12}>
                                <strong> Sexo </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 8 : 12}>
                                { 
                                    user.persona.sexoUI 
                                        ? user.persona.sexoUI
                                        : 'No especificado'
                                } 
                            </Col>
                            
                            <Col style={mt10} xs={isBrowser ? 4 : 12}>
                                <strong> Nacionalidad </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 8 : 12}>
                                { 
                                    user.persona.nacionalidadUI 
                                        ? user.persona.nacionalidadUI
                                        : 'No especificado'
                                } 
                            </Col>
                            <Col style={mt10} xs={isBrowser ? 4 : 12}>
                                <strong> Provincia </strong>
                            </Col>
                            <Col style={isBrowserMt} xs={isBrowser ? 8 : 12}>
                                {
                                    provincia
                                }
                            </Col>
                            {
                                (user.persona && user.persona.personaDnis && user.persona.personaDnis.length > 0) &&
                                <>
                                    {
                                        user.persona.personaDnis.filter(x => x && x.estado == 1).map((dni) => {
                                            return <DniTemplate isBrowserMt={isBrowserMt} key={dni.id} mt15={mt10} labelGrid={mt10} contentGrid={isBrowser ? 8 : 12} dni={dni} dniTypes={dniTypes} />
                                        })
                                    }
                                </>
                            }

                        </Row>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(UserCard);